export default {
  'verificationcheck.verifycode': 'بررسی کد تاییدیه',
  'verificationcheck.gotoprofile': 'برو به پروفایل',
  'verificationcheck.entercode': 'کد تایید را وارد نمایید',
  'verificationcheck.maintext':
    'جهت ادامه کار لطفا کد تاییدیه ارسال شده به شماره ',
  'verificationcheck.continuetext': 'را اینجا وارد نمایید',
  'verificationcheck.evaluate': 'ارزیابی',
  'verificationcheck.resendcode': 'برای ارسال مجدد کلیک کنید',
};
